import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import { Seo } from '@/components/generals/seo'
import LoadingScreen from '@/components/game/loading-screen'

// The 3D game needs WebGL and the browser, so it only renders on the client.
const GameApp = dynamic(() => import('@/components/game/game-app'), {
    ssr: false,
    loading: () => <LoadingScreen />
})

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />
            <GameApp />
        </>
    )
}

export default Home
